export default __webpack_public_path__ + "static/media/gf.99b4d16d.svg";